import React from 'react'
import sumBy from 'lodash/sumBy'
import css from './totalSales.css'
import { i18n } from '../../index'
type Data = {
  budget: number
  totalSales: number
}
type Props = {
  data: Data[]
  week: number | string
}

const WeekSummaryRow = ({ data, week }: Props) => {
  const budgetTotal = sumBy(data, 'budget')
  const salesTotal = sumBy(data, 'totalSales')
  const salesTotalLastYear = sumBy(data, 'totalSalesLastYear')
  const noBudget = budgetTotal === 0
  const noSales = salesTotal === 0
  return (
    <tr className={css.weekSummaryRow}>
      <td>{`${i18n.t('common.weekShort')} ${week}`}</td>
      <td>{noBudget ? '-' : budgetTotal}</td>
      <td>{noSales ? '-' : salesTotal}</td>
      <td>{noSales ? '-' : salesTotal - budgetTotal}</td>
      <td>{noSales ? '-' : salesTotal - salesTotalLastYear}</td>
      <td></td>
    </tr>
  )
}

export default WeekSummaryRow
